"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Path Util
 */
class Path {
    /**
     * join
     * @param {string} parts
     * @returns {string}
     */
    join(...parts) {
        return parts.map((part) => {
            return String(part)
                .replace(/\/+/g, "/")
                .replace(/^\/(.*)/, "$1")
                .replace(/(.*)\/$/, "$1");
        }).join("/");
    }
    /**
     * route
     * @param {string} routeString
     * @param params
     * @param query
     * @returns {string}
     */
    route(routeString, params = {}, query = {}) {
        Object.entries(params).forEach(([key, value]) => {
            routeString = routeString.replace(`{${key}}`, value);
            routeString = routeString.replace(`[${key}]`, value);
        });
        // Remove optional params.
        routeString = routeString.replace(/\[[^\]]+\]/, "");
        let queryString = "";
        Object.entries(query).forEach(([key, value]) => {
            queryString += key + "=" + encodeURIComponent(value) + "&";
        });
        if (routeString[routeString.length - 1] === "/") {
            routeString = routeString.slice(0, -1);
        }
        if (queryString) {
            routeString += "?" + queryString.slice(0, -1);
        }
        return routeString;
    }
}
exports.default = Path;
